import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export type GoalTypeCode =
  | 'weight_loss' | 'weight_gain' | 'health_support'
  | 'wellbeing_improvement' | 'muscle_building' | 'endurance';

export type GoalKind = 'quantitative' | 'qualitative';

/** Дзеркалить UserGoalResponseDto з api/src/modules/goals/dto/user-goal-response.dto.ts. */
export interface PmClientGoal {
  id: number;
  typeCode: GoalTypeCode;
  kind: GoalKind;
  isMain: boolean;
  rank: number;
  desiredResult: string | null;
  startValue: number | null;
  currentValue: number | null;
  targetValue: number | null;
  unit: string | null;
  targetDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GoalOption {
  typeCode: GoalTypeCode;
  kind: GoalKind;
  label: string;
}

/** Цілі довільного клієнта для продакт-менеджера (2026-10-14, read-only). */
export const getPmClientGoals = async (clientId: number): Promise<PmClientGoal[]> => {
  const response = await api.get<ApiResponse<PmClientGoal[]>>(`/pm/clients/${clientId}/goals`);
  return unwrapApiResponse<PmClientGoal[]>(response);
};

/** Погоджений список 6 типів цілей із локалізованою назвою — для підпису `typeCode` у таблиці. */
export const getGoalOptions = async (): Promise<GoalOption[]> => {
  const response = await api.get<ApiResponse<GoalOption[]>>('/goals/options');
  return unwrapApiResponse<GoalOption[]>(response);
};
